import React, { Fragment, useEffect, useState } from 'react';
import { Paper, Table, TableCell, TableContainer, TableHead, TableRow, Typography, makeStyles, TableBody, TableFooter, TablePagination, Grid, Fab } from '@material-ui/core';

import TablePaginationsArrayActions from '../../../../../UI/Table/TablePaginationArrayActions/TablePaginationsArrayActions';
// import TableBodyReminder from './TableBodyReminder/TableBodyReminder';
import { connect } from 'react-redux';
import TableBodyHistory from './TableBodyHistory/TableBodyHistory';
import { AddCircle } from '@material-ui/icons';

const useStyle = makeStyles(theme => ({
  table: {
    minWidth: 500
  },
  topTable: {
    padding: 16,
    backgroundColor: '#FAFAFA'
  },
  sideRight: {
    textAlign: 'right'
  },
  btnAdd: {
    backgroundColor: '#FF9300',
    '&:hover': {
      backgroundColor: '#FF9300'
    },
    color: '#FFFFFF',
  },
  extendedIcon: {
    marginRight: theme.spacing(1)
  }
}));

const columns = [
  { id: 'tanggal_input', label: 'Tanggal Input' },
  { id: 'tanggal_kembali', label: 'Tanggal Pengembalian Aset' },
  { id: 'pengguna', label: 'Penerima', align: 'right', minWidth: 160 },
  { id: 'Bagian', label: 'Bagian', align: 'right', minWidth: 160 },
  { id: 'keterangan', label: 'Keterangan', align: 'right', minWidth: 160 },
  { id: 'lokasi', label: 'Lokasi Perolehan', align: 'right', minWidth: 160 },
  { id: 'action', label: 'Action', align: 'right', minWidth: 20 }
];

const ListHistory = props => {

  const { assetDetail, changingHistory } = props;

  useEffect(() => {
    backPageStart();
  }, [changingHistory])

  const classes = useStyle();
  let tableBody = '';
  
  const backPageStart = () => {
    setPage(0)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(5)
  const countRows = assetDetail.history.length
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, countRows - page * rowsPerPage);

  if(assetDetail.history.length > 0){
    // console.log(assetDetail.history.length)
    tableBody = (
      <Fragment>
        <TableBody>
          {assetDetail.history.map((history) => (
            <TableBodyHistory
              history={history}
              key={history.id_history}
              editHistory={() => props.editHistory(history)}
            />
          )).reverse().slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={8} />
            </TableRow>
          )}
        </TableBody>

        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={5}
              colSpan={8}
              count={countRows}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              ActionsComponent={TablePaginationsArrayActions}
            />
          </TableRow>
        </TableFooter>
      </Fragment>
    )
  }

  return (
    <TableContainer component={Paper}>
      <div className={classes.topTable}>
        <Grid container spacing={2}>        
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <Typography variant="h4">History Pemanfaatan Asset</Typography>
          </Grid>
          <Grid item lg={8} md={8} sm={12} xs={12}>
            <div className={classes.sideRight}>
              <Fab variant="extended" className={classes.btnAdd} onClick={() => props.addHistory()}>
                <AddCircle className={classes.extendedIcon} />
                Penerima
              </Fab>
            </div>
          </Grid>      
        </Grid>
      </div>
      <hr/>
      <Table className={classes.table} aria-label="custom pagination table">
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.id}
                align={column.align}
                style={{ minWidth: column.minWidth }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        {tableBody}
      </Table>
    </TableContainer>
  )
}

const mapStateToProps = state => {
  return {
    changingHistory: state.assetDetail.change
  }
}

export default connect(mapStateToProps)(ListHistory);